import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    width: 44,
    height: 44,
    cursor: 'pointer'
  },
  icon: {
    width: 25,
    color: '#263057'
  },
  iconContainer: {
    width: 44,
    height: 44,
    display: 'flex',

    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  iconActive: {
    width: 44,
    height: 44,
    display: 'flex',
    marginleft: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    backgroundColor: '#fff',
    '& #iconActive': {
      color: '#fff'
    }
  },
  iconList: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 24
  }
}))

export default useStyles
